<template>
    <div class="DriverEditPage">
        <DashboardSectionHeader title="Edit Driver">
            <Button to="/company/drivers" class="link primary">Cancel</Button>
            <Button class="primary" @click="handleSave" :disabled="submitPending">Save</Button>
        </DashboardSectionHeader>

        <p class="errorMessage" v-if="submitError">{{ submitError }}</p>

        <DriverEditForm
            ref="driverForm"
            v-if="driver"
            v-bind.sync="driver"
            :di_type.sync="driver.driverInfo.type"
            :di_employeeCode.sync="driver.driverInfo.employeeCode"
            :di_driverLicense.sync="driver.driverInfo.driverLicense"
            :di_rate.sync="driver.driverInfo.rate"
            :di_hiredAt.sync="driver.driverInfo.hiredAt"
            :di_medicalExpireAt.sync="driver.driverInfo.medicalExpireAt"
        />

        <p class="errorMessage" v-if="submitError">{{ submitError }}</p>

        <DashboardSectionHeader>
            <Button to="/company/drivers" class="link primary">Cancel</Button>
            <Button class="primary" @click="handleSave" :disabled="submitPending">Save</Button>
        </DashboardSectionHeader>
    </div>
</template>

<script>
import * as api from '@/api';
import { cloneDeep } from 'lodash';
import createPatch from '@/utils/createPatch';
import DashboardSectionHeader from '@/components/DashboardSectionHeader';
import DriverEditForm from './components/DriverEditForm.vue';

export default {
    name: 'DriverEditPage',

    components: {
    DashboardSectionHeader,
    DriverEditForm
},

    data: () => ({
        driverRef: null,
        driver: null,

        fetchPending: false,
        fetchError: null,
        submitPending: false,
        submitError: null,
    }),

    computed: {
        id() {
            return this.$route.params.id;
        },
    },

    mounted() {
        this.fetchDriver();
    },

    methods: {
        async fetchDriver() {
            this.fetchPending = true;
            const res = await api.getUser(this.id);
            this.fetchPending = false;

            if (res.error) {
                this.fetchError = res.error;
                return this.$awn.alert('Failed to fetch driver');
            }

            this.setDriver(res.body);
        },

        async handleSave() {
            if (!this.$refs.driverForm.validate()) {
                return;
            }

            const patch = createPatch(this.driverRef, this.driver);
            patch.email = this.driver.email?.trim() || null;
            patch.username = this.driver.username?.trim() || null;

            this.submitPending = true;
            this.submitError = null;
            const res = await api.updateUser(patch);
            this.submitPending = false;

            if (res.error) {
                // TODO: send better errors to the client from the back-end (requires refactoring)
                if (res.error.message.startsWith('duplicate key value violates unique constraint')) {
                    this.submitError = 'Email/Username is already taken';
                } else {
                    this.submitError = res.error.message;
                }

                return this.$awn.alert('Failed to update driver');
            }

            this.setDriver(res.body);
            this.$awn.success('Driver has been updated!');
        },

        setDriver(driver) {
            delete driver.company;

            this.driverRef = cloneDeep(driver);
            this.driver = driver;
        },
    },
}
</script>


<style lang="scss">
@import 'globals.scss';

.DriverEditPage {
    .errorMessage {
        margin: 1rem 0;
        color: $red-color;
        text-align: right;
    }
}
</style>
